require('./insuranceRequestPolicySummary.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @ commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @ utilities
const { getFormattedString } = require('utilities/currencyHelper');

// @ components
const insuranceRequestBuildPlanItem = require('../../insuranceRequestCompilationCard/insuranceRequestBuildPlanItem')
const insuranceRequestBuildPrimeItem = require('../../insuranceRequestCompilationCard/insuranceRequestBuildPrimeItem')
const insuranceRequestBuildRelatedAddressItem = require('../../insuranceRequestCompilationCard/insuranceRequestBuildRelatedAddressItem')
const insuranceRequestBuildAddressItem = require('../../insuranceRequestCompilationCard/insuranceRequestBuildAddressItem')
const insuranceRequestBuildPaymentTypeItem = require('../../insuranceRequestCompilationCard/insuranceRequestBuildPaymentTypeItem')
const insuranceRequestBuildContinentContentItem = require('../../insuranceRequestCompilationCard/insuranceRequestBuildContinentContentItem')
const insuranceRequestBuildStartDate = require('./insuranceRequestBuildStartDate')
const insuranceRequestBuildAccount = require('./insuranceRequestBuildAccount')

// @ constants
const { text } = require('../../../insuranceConstants/insuranceRequestHome');
const { EURO_TEXT } = require('constants/index');

const formatCurrency = (amount, decimalsLength = 0) => {
    return getFormattedString({
        amount: amount,
        currency: EURO_TEXT,
        decimalsLength
    });
}

const pricingTextTemplate = (paymentType, pricing) => (
    `
        ${text().SUMMARY.FIRST_IMPORT[paymentType]}
        <span className="insurance-request-compilation-card__summary-text-complementary--important">
            ${formatCurrency(pricing.get('firstImport'), 2)}
        </span>
        <br />
        ${text().SUMMARY.SUCCESSIVE_IMPORT[paymentType]}
        <span className="insurance-request-compilation-card__summary-text-complementary--important">
            ${formatCurrency(pricing.get('succesiveReceiptsImport'), 2)}
        </span>
    `
)

const handleDropDownClick = (evt, paymentType, pricing) => {
    const { target } = evt
    const { parentElement: {
        parentElement
    } } = target
    const { className } = target
    const isOpenClass = className.includes("abrir")
    if (isOpenClass) {
        target.className = "insurance-request-policy-summary__icon icon-accordion-cerrar";
        const spanElement = document.createElement("span")
        spanElement.className = "insurance-request-compilation-card__summary-text-complementary"
        spanElement.innerHTML = pricingTextTemplate(paymentType, pricing);
        parentElement.appendChild(spanElement)
    } else {
        evt.target.className = "insurance-request-policy-summary__icon icon-accordion-abrir";
        parentElement.removeChild(parentElement.lastElementChild)

    }
}

const InsuranceRequestPolicySummary = ({
    immInsuranceState,
    hasSimulation,
    hasSimulationChanged,
    immInsuranceWizardState,
    isRelated,
    immAccounts,
    isRnc,
    isPostAppraisal
}) => {
    const dropDown = true;
    const isFromSummary = true;
    const buildPrimeItem = insuranceRequestBuildPrimeItem(immInsuranceState, immInsuranceWizardState, hasSimulation, hasSimulationChanged, isFromSummary, isRnc);
    const buildPlanItem = insuranceRequestBuildPlanItem(immInsuranceState, hasSimulation, hasSimulationChanged, immInsuranceWizardState);
    const BuildPaymentTypeItem = insuranceRequestBuildPaymentTypeItem(immInsuranceState, immInsuranceWizardState, hasSimulation, hasSimulationChanged, dropDown, isRnc);
    const buildContinentItem = insuranceRequestBuildContinentContentItem('continent', 'summaryContinent', immInsuranceWizardState, isRelated);
    const buildAccount = insuranceRequestBuildAccount(immAccounts, immInsuranceWizardState);
    const buildAddressItem = isRelated ? insuranceRequestBuildRelatedAddressItem(immInsuranceState, immInsuranceWizardState) : insuranceRequestBuildAddressItem(immInsuranceWizardState);
    const buildContentItem = insuranceRequestBuildContinentContentItem('content', 'summaryContent', immInsuranceWizardState, isRelated);
    const buildStartDate = insuranceRequestBuildStartDate(immInsuranceWizardState);

    let list = [buildPrimeItem, buildPlanItem, BuildPaymentTypeItem, buildContinentItem, buildAccount, buildContentItem, buildAddressItem, buildStartDate];
    if (isRelated) {
        list = [buildPrimeItem, buildPlanItem, BuildPaymentTypeItem, buildContinentItem, buildAccount, buildContentItem, buildAddressItem];
        if (!isPostAppraisal) {
            list = [buildPrimeItem, buildContinentItem, buildPlanItem, buildContentItem];
        } else if (isRnc) {
            list = [buildPrimeItem, buildPlanItem, BuildPaymentTypeItem, buildContinentItem, buildAddressItem, buildContentItem];
        }
    }

    const listComponent = list.map((item, index) => {
        if (item.flag === "paymentTypeWithDropdown") {
            return (
                <li className="insurance-request-policy-summary__container" key={index}>
                    <p className="insurance-request-policy-summary__title">
                        {item.label}
                        <span
                            className="insurance-request-policy-summary__icon icon-accordion-abrir"
                            onClick={(evt) => { handleDropDownClick(evt, item.paymentType, item.pricing) }}
                        />
                    </p>
                    <p className="insurance-request-policy-summary__body-text">{item.text}</p>
                </li>
            )
        }
        const classNames = classnames('insurance-request-policy-summary__ok-informative-list-item', item.className)
        return (
            <OKInformativeListItem
                bodyText={item.text}
                className={classNames}
                icon={item.icon}
                iconCustomClass={item.iconCustomClass}
                information={item.information}
                key={index}
                title={item.label}
                tooltipClassName={item.tooltipClassName}
                tooltipOffset={item.tooltipOffset}
                tooltipPlacement={item.tooltipPlacement}
                bodyWordBreak={false}
                compact
            />
        )
    });

    return (
        <OKInformativeList columns={2}>
            {listComponent}
        </OKInformativeList>
    );
}


InsuranceRequestPolicySummary.propTypes = {
    immInsuranceState: PropTypes.object.isRequired,
    hasSimulation: PropTypes.bool.isRequired,
    hasSimulationChanged: PropTypes.bool.isRequired,
    immInsuranceWizardState: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    isRelated: PropTypes.bool.isRequired,
    isRnc: PropTypes.bool.isRequired,
    isPostAppraisal: PropTypes.bool,
};

InsuranceRequestPolicySummary.defaultProps = {
    isRnc: false
};


module.exports = InsuranceRequestPolicySummary;
